var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TopToolbar'),_c('v-content',[_c('router-view',{on:{"authenticated":_vm.setAuthenticated}})],1),_c('BottomNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }